import { buttonStyling } from "../button/Shared";
import { ColorSystem } from "../colors/color";
import { cardStyles } from "./cardStyles";
import { tableStyles } from "./tableStyles";
import { PStyling, SmallStyling } from "./typography";

export const amorgStyles = (color:ColorSystem) => 
({
    P:PStyling,
    Small:SmallStyling,
    
    card:cardStyles(color),
    button2:buttonStyling(color),
    table:tableStyles(color)
});

export type AmorgStyles = ReturnType<typeof amorgStyles>;